<template>
  <div class="home" style="height: 1000px;">
	<HaaaWooo/>
  </div>
</template>

<script>
// @ is an alias to /src
import HaaaWooo from '@/components/HaaaWooo'
// import { ModalProvider } from '@particle-network/connect-react-ui';
// import { WalletEntryPosition } from '@particle-network/auth';
// import { Ethereum, EthereumGoerli } from '@particle-network/chains';
// import { evmWallets } from '@particle-network/connect';
// console.log(ModalProvider,WalletEntryPosition, Ethereum, EthereumGoerli,evmWallets)
// import React from 'react'
// let root=document.querySelector("#root");


export default {
  name: 'HomeView',
  components: {
    HaaaWooo
  },
  data() {
	return {
		'haah':"haha",
	}
  }
}

</script>
